(function () {
  'use strict';

  var main = document.getElementById('lm-main-img');
  var thumbs = Array.from(document.querySelectorAll('.lm-thumbs button'));

  thumbs.forEach(function (button) {
    button.addEventListener('click', function () {
      if (!main) return;
      var srcset = button.getAttribute('data-srcset');
      if (srcset) main.setAttribute('srcset', srcset);
      else main.removeAttribute('srcset');
      main.src = button.getAttribute('data-full');
      main.alt = button.getAttribute('data-alt') || '';
      thumbs.forEach(function (item, i) {
        var selected = item === button;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-pressed', String(selected));
        if (dots[i]) dots[i].classList.toggle('active', selected);
      });
    });
  });

  var galleryMain = main && main.closest('.lm-gallery-main');
  var dots = galleryMain ? Array.from(galleryMain.querySelectorAll('.lm-dots span')) : [];
  if (galleryMain && thumbs.length > 1) {
    var startX = 0, startY = 0, tracking = false;
    galleryMain.addEventListener('touchstart', function (e) {
      tracking = true;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    }, { passive: true });
    galleryMain.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var dx = e.touches[0].clientX - startX;
      var dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy)) e.preventDefault();
    }, { passive: false });
    galleryMain.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - startX;
      var dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var current = thumbs.findIndex(function (b) { return b.classList.contains('active'); });
      if (current < 0) current = 0;
      var next = (current + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
      thumbs[next].click();
      // Keep iOS Safari's horizontal movement inside the thumbnails only.
      // scrollIntoView() can unexpectedly scroll the whole document.
      var thumbStrip = thumbs[next].closest('.lm-thumbs');
      if (thumbStrip) {
        var thumbRect = thumbs[next].getBoundingClientRect();
        var stripRect = thumbStrip.getBoundingClientRect();
        var targetLeft = thumbStrip.scrollLeft + thumbRect.left - stripRect.left
          - (thumbStrip.clientWidth - thumbRect.width) / 2;
        thumbStrip.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
      }
    }, { passive: true });
  }

  var form = document.getElementById('lm-form');
  var idInput = document.getElementById('lm-variant-id');
  var atc = document.getElementById('lm-atc');
  var sticky = document.getElementById('lm-sticky');
  var stickyButton = sticky && sticky.querySelector('[data-sticky-atc]');
  var offers = Array.from(document.querySelectorAll('.lm-offer[data-variant-id]'));
  var prices = document.querySelectorAll('[data-atc-price], [data-sticky-price]');
  var stickyTitle = document.querySelector('[data-sticky-title]');

  function selectOffer(offer, moveFocus) {
    if (!offer || offer.disabled) return;
    offers.forEach(function (item) {
      var selected = item === offer;
      item.classList.toggle('active', selected);
      item.setAttribute('aria-checked', String(selected));
      item.tabIndex = selected ? 0 : -1;
    });
    if (idInput) idInput.value = offer.getAttribute('data-variant-id');
    if (atc) {
      atc.disabled = false;
      if (!atc.querySelector('[data-atc-price]')) {
        atc.textContent = 'Ajouter au panier · ';
        var price = document.createElement('span');
        price.setAttribute('data-atc-price', '');
        atc.appendChild(price);
        prices = document.querySelectorAll('[data-atc-price], [data-sticky-price]');
      }
    }
    prices.forEach(function (element) {
      element.textContent = offer.getAttribute('data-price');
    });
    if (stickyTitle) stickyTitle.textContent = offer.getAttribute('data-offer-title');
    if (stickyButton) {
      stickyButton.disabled = false;
      stickyButton.textContent = 'Ajouter au panier';
    }
    if (moveFocus) offer.focus();
  }

  offers.forEach(function (offer) {
    offer.addEventListener('click', function () { selectOffer(offer, false); });
    offer.addEventListener('keydown', function (event) {
      var available = offers.filter(function (item) { return !item.disabled; });
      var index = available.indexOf(offer);
      var next;
      if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
        next = available[(index + 1) % available.length];
      } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
        next = available[(index - 1 + available.length) % available.length];
      } else if (event.key === 'Home') {
        next = available[0];
      } else if (event.key === 'End') {
        next = available[available.length - 1];
      } else { return; }
      event.preventDefault();
      selectOffer(next, true);
    });
  });

  var initialOffer = offers.find(function (offer) {
    return !offer.disabled && idInput && offer.getAttribute('data-variant-id') === idInput.value;
  });
  if (initialOffer) { selectOffer(initialOffer, false); }
  else {
    var firstAvailable = offers.find(function (offer) { return !offer.disabled; });
    if (firstAvailable) selectOffer(firstAvailable, false);
  }

  function addBusinessDays(date, count) {
    var result = new Date(date);
    while (count > 0) {
      result.setDate(result.getDate() + 1);
      var day = result.getDay();
      if (day !== 0 && day !== 6) count--;
    }
    return result;
  }

  function validDays(value, fallback) {
    var number = Number(value);
    return Number.isFinite(number) && number >= 0 ? Math.floor(number) : fallback;
  }

  function formatDate(date) {
    return date.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' });
  }

  var ship = window.LM_SHIP || {};
  var shipMin = validDays(ship.min, 7);
  var shipMax = Math.max(shipMin, validDays(ship.max, 12));
  var now = new Date();
  document.querySelectorAll('[data-ship-from]').forEach(function (el) { el.textContent = formatDate(addBusinessDays(now, shipMin)); });
  document.querySelectorAll('[data-ship-to]').forEach(function (el) { el.textContent = formatDate(addBusinessDays(now, shipMax)); });

  var mobile = window.matchMedia('(max-width: 900px)');
  var atcPassed = false;

  function syncSticky() {
    if (!sticky) return;
    var show = mobile.matches && atcPassed;
    sticky.classList.toggle('show', show);
    sticky.setAttribute('aria-hidden', String(!show));
    sticky.toggleAttribute('inert', !show);
    document.body.classList.toggle('lm-has-sticky', show);
  }

  if (atc && sticky) {
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        atcPassed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 64;
        syncSticky();
      }, { rootMargin: '-64px 0px 0px 0px' }).observe(atc);
    } else {
      var scheduled = false;
      function updatePosition() { atcPassed = atc.getBoundingClientRect().bottom <= 64; syncSticky(); scheduled = false; }
      window.addEventListener('scroll', function () { if (scheduled) return; scheduled = true; window.requestAnimationFrame(updatePosition); }, { passive: true });
      window.addEventListener('resize', updatePosition);
      updatePosition();
    }
    if (mobile.addEventListener) { mobile.addEventListener('change', syncSticky); }
    else { mobile.addListener(syncSticky); }
  }

  if (stickyButton) {
    stickyButton.addEventListener('click', function () {
      if (!form || !atc || atc.disabled) return;
      if (form.requestSubmit) form.requestSubmit(atc);
      else atc.click();
    });
  }

  window.lmCartChange = function (line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function () { location.reload(); });
  };
})();

(function () {
  var reveal = document.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window && reveal.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: .08 });
    reveal.forEach(function (el) { io.observe(el); });
  } else { reveal.forEach(function (el) { el.classList.add('is-in'); }); }
  var header = document.querySelector('.lm-brand-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 24); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
})();

(function () {
  document.querySelectorAll('.lm-ba').forEach(function (ba) {
    var range = ba.querySelector('.lm-ba__range');
    if (!range) return;
    var set = function () { ba.style.setProperty('--pos', range.value + '%'); };
    range.addEventListener('input', set);
    set();
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (e) {
        if (!e[0].isIntersecting) return; io.disconnect();
        var steps = [50, 30, 70, 50], i = 0;
        var tick = function () { range.value = steps[i++]; set(); if (i < steps.length) setTimeout(tick, 450); };
        setTimeout(tick, 400);
      }, { threshold: .5 });
      io.observe(ba);
    }
  });
})();
